import xdk from '@accedo/xdk-core'
import { ID as TIZEN } from '@accedo/xdk-device-samsung-tizen'

export const getDeeplinkPath = () => {
  let path: string | null = null

  const isTizen = xdk?.platform === TIZEN

  if (isTizen) {
    path = getTizenDeeplinkPath()
  } else {
    path = location?.search?.replace('?', '')
  }

  return path
}

export const getTizenDeeplinkPath = () => {
  let path: string | null = null

  if (!window?.tizen) return null

  const requestedAppControl = window.tizen.application
    .getCurrentApplication()
    .getRequestedAppControl()

  if (requestedAppControl) {
    const appControlData = requestedAppControl.appControl.data

    for (let i = 0; i < appControlData.length; i += 1) {
      if (appControlData[i].key == 'PAYLOAD') {
        const actionData = JSON.parse(appControlData[i].value[0]).values

        path = actionData
      }
    }
  }

  return path
}
